import { useCallback, useState } from 'react';

import { CatalogItemStatus } from '../types/catalogItem';

export interface CatalogItemFilters {
  searchName: string;
  filterCatalogGroupId: string | undefined;
  filterStatus: CatalogItemStatus;
}

export function useCatalogItemFilters(initialStatus: CatalogItemStatus = 'approved') {
  const [searchName, setSearchName] = useState('');
  const [filterCatalogGroupId, setFilterCatalogGroupId] = useState<string | undefined>(undefined);
  const [filterStatus, setFilterStatus] = useState<CatalogItemStatus>(initialStatus);

  const clearFilters = useCallback(() => {
    setSearchName('');
    setFilterCatalogGroupId(undefined);
    setFilterStatus('approved');
  }, []);

  const filters: CatalogItemFilters = {
    searchName,
    filterCatalogGroupId,
    filterStatus,
  };

  return {
    filters,
    setSearchName,
    setFilterCatalogGroupId,
    setFilterStatus,
    clearFilters,
  };
}
